:host {
  /** @prop --link-item-padding-size: Set the size of the padding around the link item. */
  --link-item-padding-size: 20px;

  /** @prop --link-item-padding-vertical: Set the size of the vertical padding. */
  --link-item-padding-vertical: var(--link-item-padding-size);

  /** @prop --link-item-padding-bottom: Set the size of the bottom padding. */
  --link-item-padding-bottom: var(--link-item-padding-vertical);

  /** @prop --link-item-padding-horizontal: Set the size of the horizontal padding. */
  --link-item-padding-horizontal: calc(var(--link-item-padding-size) * 2);

  /** @prop --link-item-padding-shorthand: Set the shorthand for all padding values. */
  --link-item-padding-shorthand: var(--link-item-padding-top) var(--link-item-padding-right) var(--link-item-padding-bottom) var(--link-item-padding-left);

  /** @prop --link-item-padding-top: Set the size of the top padding. */
  --link-item-padding-top: var(--link-item-padding-vertical);

  /** @prop --link-item-padding-left: Set the size of the left padding. */
  --link-item-padding-left: var(--link-item-padding-horizontal);

  /** @prop --link-item-padding-right: Set the size of the right padding. */
  --link-item-padding-right: var(--link-item-padding-horizontal);

  /** @prop --link-item-chevron-margin: Set the margin around the chevron icon. */
  --link-item-chevron-margin: var(--link-item-padding-size);

  /** @prop --link-item-link-gap: Set the gap between link items. */
  --link-item-gap: calc(var(--link-item-padding-size) / 2) var(--link-item-padding-size);

  /** @prop --link-item-background-color: Set the background color of the link item. */
  --link-item-background-color: var(--s-color-background-default-default);

  /** @prop --link-item-border-color: Set the color of the link item border. */
  --link-item-border-color: var(--s-color-border-divider);

  /** @prop --link-item-border-size: Set the size of the link item border. */
  --link-item-border-size: var(--p-size-static-0125);

  /** @prop --link-item-border-radius: Set the border radius. */
  --link-item-border-radius: 0px;

  /** @prop --link-item-hover-background-color: Set the hover color of the background. */
  --link-item-hover-background-color: var(--s-color-background-default-default);

  /** @prop --link-item-hover-filter: Set the hover filter for the background. */
  --link-item-hover-filter: brightness(95%);

  /** @prop --link-item-border-style: Set the border style. */
  --link-item-border-style: solid;

  /** @prop --link-item-border: Set the shorthand for the link item border. */
  --link-item-border: var(--link-item-border-size) var(--link-item-border-style) var(--link-item-border-color);

  /** @prop --link-item-box-sizing: Set the box sizing of the link item. */
  --link-item-box-sizing: border-box;

  /** @prop --padding-size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-size: var(--link-item-padding-size);

  /** @prop --padding-bottom: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-bottom: var(--link-item-padding-bottom);

  /** @prop --padding-horizontal: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-horizontal: var(--link-item-padding-horizontal);

  /** @prop --padding-shorthand: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-shorthand: var(--link-item-padding-shorthand);

  /** @prop --padding-top: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-top: var(--link-item-padding-top);

  /** @prop --padding-left: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-left: var(--link-item-padding-left);

  /** @prop --padding-right: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --padding-right: var(--link-item-padding-right);

  /** @prop --chevron-margin: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --chevron-margin: var(--link-item-chevron-margin);

  /** @prop --gap: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --gap: var(--link-item-gap);

  /** @prop --background-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --background-color: var(--link-item-background-color);

  /** @prop --border-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-color: var(--link-item-border-color);

  /** @prop --border-size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-size: var(--link-item-border-size);

  /** @prop --border-style: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border-style: var(--link-item-border-style);

  /** @prop --border: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --border: var(--link-item-border);

  /** @prop --box-sizing: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --box-sizing: var(--link-item-box-sizing);

  .link-content {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    gap: var(--link-item-gap);
    @media screen and (max-width: 599px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .link,
  ::slotted(.content),
  ::slotted([slot|='content']) {
    --link-item-padding-shorthand: var(--link-item-padding-top) var(--link-item-padding-right) var(--link-item-padding-bottom) var(--link-item-padding-left);
    padding: var(--link-item-padding-shorthand);
  }
}

.box {
  box-sizing: var(--link-item-box-sizing);
  border: var(--link-item-border);
}

.anchor-c-link-item {
  background-color: var(--link-item-background-color);
  border-bottom: var(--link-item-border);
  border-radius: var(--link-item-border-radius);
  color: var(--s-color-text-default);
  width: 100%;
  &:hover {
    filter: var(--link-item-hover-filter);
    background-color: var(--link-item-hover-background-color);
  }
  anchor-icon {
    color: var(--s-color-icon-brand);
  }
  &:not(.box).focused {
    box-shadow: inset 0 0 0 var(--link-item-border-size) var(--s-color-outline-default);
    .header anchor-icon {
      color: currentColor;
    }
  }
  &.box.focused {
    // custom focused handler because nested content.
    border-color: var(--b-color-black);
    box-shadow: none;
    outline-color: var(--s-color-outline-default);
    outline-width: var(--p-size-static-025);
    // border: var(--p-size-static-0125) solid var(--s-color-outline-default);
    .header anchor-icon {
      color: currentColor;
    }
  }
  .link {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    color: var(--s-color-text-default);
    anchor-icon {
      color: var(--s-color-icon-brand);
      margin-left: var(--link-item-chevron-margin);
    }
    &:visited {
      color: var(--s-color-text-default);
    }
    &:hover anchor-icon {
      color: currentColor;
    }
    &:focus {
      outline-width: 0;
      box-shadow: none;
    }
  }
  .content-container {
    display: none;
  }
}
